import React from 'react';
import { Grid, Typography, Tooltip, Button, WithStyles } from '@material-ui/core';
import DeletePopUp from '../wrapperComponent/popUps';
import { MyPATLink } from '../../../../common';
import { getPageNumber } from './utils';
import styles from './RemedialQuestionStyles';
import { REMEDIAL_QUESTION_DELETE_TEXT } from './stringConstant';

interface RemedialSelectedIndivualComponentProps extends WithStyles<typeof styles> {
    pageKeyName: string;
    pageState: any;
    deletePopUpDialog: boolean;
    handleOpenDeleteDialog: Function;
    handleReplaceQuestion: Function;
    handleCloseDialog: () => void;
    handleDeletePageWithPopUp: Function;
    deleteKeyForPage: string;
    classes: any
}

const RemedialSelectedIndivualComponent = (props: RemedialSelectedIndivualComponentProps) => {
    const {
        classes,
        pageKeyName,
        pageState,
        deletePopUpDialog,
        handleOpenDeleteDialog,
        handleReplaceQuestion,
        handleCloseDialog,
        handleDeletePageWithPopUp,
        deleteKeyForPage
    } = props
    const pageNo = getPageNumber(pageKeyName);
    
    return (
        <div className={classes.root}>
            <Grid
                container
                spacing={8}
                alignItems="center"
                justify="space-between"
                wrap="nowrap"
                className={classes.mb1x}
            >
                <Grid item xs="auto">
                    <div className={classes.padRgt10} key={pageNo}>Q.{pageNo}</div>
                </Grid>
                <Grid item xs className={classes.maxWidth90}>
                    <Grid container alignItems="center" wrap="nowrap" className={classes.questionInfo}>
                        <Grid item xs={9}>
                            <Typography variant="body1" classes={{ root: classes.questionParagraph }} noWrap>
                                <span
                                    className={classes.pTagmargin}
                                    dangerouslySetInnerHTML={{
                                        __html: pageState[pageKeyName].question.title || '',
                                    }}
                                />
                            </Typography>
                        </Grid>
                        <Grid item xs className={classes.textAlignRight}>
                            <Typography variant="body1" noWrap>
                                ID:{' '}
                                <span className={classes.quesId}>
                                    <MyPATLink
                                        to={`/content/preview/${pageState[pageKeyName].question.content_Id}question`}
                                        target="_blank"
                                    >
                                        {pageState[pageKeyName].question.searchId.toUpperCase()}
                                    </MyPATLink>
                                </span>
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs="auto">
                    <Tooltip title="Delete" placement="top">
                        <Button
                            variant="outlined"
                            className={`${classes.questionActionBtn} btn-delete`}
                            onClick={() => handleOpenDeleteDialog(pageKeyName)}
                        >
                            <img src="/assets/svg/myLibrary/delete-outline.svg" alt="Delete" />
                        </Button>
                    </Tooltip>
                </Grid>
                <Grid item xs="auto">
                    <Tooltip title="Replace" placement="right-start">
                        <Button
                            variant="outlined"
                            className={`${classes.questionActionBtn} btn-delete`}
                            onClick={() => handleReplaceQuestion(pageKeyName)}
                        >
                            <img src="/assets/svg/learn/flipQuestion.svg" alt="Replace" />
                        </Button>
                    </Tooltip>
                </Grid>
                <DeletePopUp
                    openDialog={deletePopUpDialog}
                    handleClose={handleCloseDialog}
                    deleteFunction={() => handleDeletePageWithPopUp(deleteKeyForPage)}
                    deleteText={REMEDIAL_QUESTION_DELETE_TEXT}
                />
            </Grid>
        </div>
    );
};

export default RemedialSelectedIndivualComponent;
